module.exports = __webpack_public_path__ + "img/eon.8493a77e.jpeg";